import React, { useContext } from "react";

import { AsyncTypeahead } from "../../form-inputs/typeahead";
import { getAttributesByTerm } from "../../attributes/lib/attribute-data";
import { AttributesContext } from "../../../contexts/attributes";

const AddAttributeSearch = (props) => {
    const attributes = useContext(AttributesContext);

    const onAttributeSelect = async (name, attr) => {
        attributes.add(attr, null, true, true, props.isSuccess, props.taskType, props.isBrandVerified);
    };

    const loadOptions = async (term) => {
        let result = await getAttributesByTerm(term, props.wipKey, props.taskKey);

        return props.taskType === undefined
            ? result
            : result.filter((r) => r.hiddenAttributeTaskInfo === null || r.hiddenAttributeTaskInfo.filter((n) => n === props.taskType).length === 0);
    };

    const brandModifiedCopy = props.isBrandVerified ? "" : "Add/";

    return (
        <div className={props.cssClass || "button-group -right"}>
            <AsyncTypeahead
                name="search_attributes"
                accessKey="a"
                clearOnSelect={true}
                placeholder={`${brandModifiedCopy}Search Attribute (Alt+a)`}
                updateOnChange={onAttributeSelect}
                loadOptions={loadOptions}
                multiSelect={true}
                disabled={props.disabled}
            />
        </div>
    );
};

export default AddAttributeSearch;
